import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"

export const CheckboxContainer = styled.div`
  display: flex;
  position: relative;
  align-items: baseline;
  padding: 0;
  height: 100%;
`

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  border-radius: 3px;
  background: #e3e6e7;
  border: 1px solid #6a747c;
  transition: background 90ms;
  pointer-events: none;
  margin-top: 23px;
  margin-bottom: 20px;
  margin-left: 20px;

  ::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    transition: 100ms;
    width: 7px;
    height: 12px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: translate3d(-50%, -40%, 0) scale(0.3) rotate(45deg);
  }

  ${CheckboxContainer}:hover & {
    background: #ccc;
  }
`

export const Input = styled.input`
  opacity: 0;
  height: 0;
  width: 0;

  /* make input clickable region reach the entire container div */
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  /* show checkmark pseudo when input is checked */
  :checked ~ span.checkmark {
    background: #007eae;

    ::after {
      opacity: 1;
      transform: translate3d(-50%, -60%, 0) scale(1) rotate(45deg);
    }
  }
`

export const Label = styled.label`
  font-size: 16px;
  color: #4a5a80;
  letter-spacing: -0.25px;
  line-height: 30px;
  display: block;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 60px;
  padding-right: 20px;

  @media ${device.desktop} {
    font-size: 20px;
  }

  ${CheckboxContainer}:hover & {
    color: #414d69;
  }
`

export const ErrorMessage = styled.p`
  color: red;
  margin-bottom: 10px;
  font-size: 14px !important;
`
